import { render } from "./FilmWithCheckbox.vue?vue&type=template&id=489cf9e9&scoped=true"
import script from "./FilmWithCheckbox.vue?vue&type=script&lang=js"
export * from "./FilmWithCheckbox.vue?vue&type=script&lang=js"

import "./FilmWithCheckbox.vue?vue&type=style&index=0&id=489cf9e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489cf9e9"]])

export default __exports__